$(function($) {
    $( ".pagina" ).each(function() {
        $( this ).show();
        id = $( this ).attr("pageid");
        if(id != 1){
            $( this ).hide();
        }
    });

    $('.showPage').click(function () {
        $('html, body').animate({
            scrollTop: $('.sectionFoodProductsHome .productsList').offset().top - 0
        }, 2000);
        var page = this.id;
        var idlink = this.name;
        //location.href = '#products';
        $( ".linkpg" ).each(function() {
            $( this ).removeClass('active');
        });
        $( '#pg'+idlink ).addClass("active");
        $( ".pagina" ).each(function() {
            $( this ).show();
            var id = $( this ).attr("pageid");
            if(id != page){
                $( this ).hide();
            }
        });
    });

    $('.sectionFoodProductsHome .rowOne h3').click(function () {
        $('.sectionFoodProductsHome .rowOne h3').removeClass('active');
        $(this).addClass('active');
        $.ajax({
            url: https + "/getProducts",
            method: "POST",
            data: {id_type: this.id, action: 'getProducts'},
            success: function (data) {
                $('.sectionFoodProductsHome .productsList').html('');
                $('.sectionFoodProductsHome .productsList').html(data);
            }
        });
    });

    $('.sectionFoodProductsHome .rowOne select').change(function () {
        $.ajax({
            url: https + "/getProducts",
            method: "POST",
            data: {id_type: $('.sectionFoodProductsHome .rowOne select').val(), action: 'getProducts'},
            success: function (data) {
                $('.sectionFoodProductsHome .productsList').html('');
                $('.sectionFoodProductsHome .productsList').html(data);
            }
        });
    });
});

